import { Skeleton } from '@mantine/core';
import { useProjectId } from '~/hooks/context/useProjectId';
import { api } from '~/trpc-extra/api';

export default function ProjectName() {
  const projectId = useProjectId();

  const { data: projectName } = api.project.getProjectName.useQuery(
    {
      projectId: projectId || '',
    },
    // This doesn't change often so disable refetching
    { enabled: !!projectId, refetchOnMount: false, refetchOnWindowFocus: false },
  );

  return (
    <>
      {projectId ?
        projectName ?
          <div className="max-w-[300px] flex-shrink-0 hyphens-auto break-words px-1 text-sm font-bold leading-4 text-stone-600 md:text-lg xl:max-w-[400px] dark:text-stone-400">
            {projectName}
          </div>
        : <Skeleton className="h-8 w-full flex-shrink-0" />
      : undefined}
    </>
  );
}
